<div>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Documento Comprobatório</h4>
    <button type="button" (click)="onDismiss(false)" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="my-auto row">
      <div class="col-12 d-flex flex-column">
        <iframe *ngIf="documentPreviewUrl && isPdf()" [src]="documentPreviewUrl" frameborder="0"
          class="flex-grow-1 border rounded" style="width: 100%; height: 100%; overflow: hidden;"></iframe>
        <div *ngIf="documentPreviewUrl && isImage()"
          class="flex-grow-1 d-flex justify-content-center align-items-start border rounded"
          style="width: 100%; max-height: 80vh; overflow-y: auto; overflow-x: hidden;">
          <img [src]="documentPreviewUrl" alt="Visualização de documento" style="max-width: 100%; height: auto;" />
        </div>
        <div *ngIf="!documentPreviewUrl;"
          class="text-center flex flex-1 h-full flex-column justify-content-center align-items-center gap-2">
          <span class="spinner-border text-primary spinner-border-lg mr-1"></span>
          Carregando documento
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" *ngIf="timeOccurrence?.pendingApproval || timeOccurrence?.leaderId">
    <button type="button" [disabled]="isLoading" class="btn btn-outline-secondary" (click)="onDismiss(false)" rippleEffect>
      Fechar
    </button>
    <button [disabled]="isLoading" type="button" (click)="openReproveAbsence()" class="btn btn-gradient-danger" rippleEffect>
      Reprovar <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
    </button>
  </div>
</div>